<template>
  <div>
    <b-carousel
      id="carousel-1"
      :interval="4000"
      indicators
      fade
      class="my-carousel"
    >
      <b-carousel-slide>
        <template #img>
          <img src="@/assets/images/home/home5.jpg" width="100%" />
          <div class="overlay"></div>
        </template>
        <b-container class="h-100">
          <div class="d-flex align-items-center h-100">
            <div class="d-flex flex-column pt-4 animate-text">
              <div class="pt-2 text-left">
                <h1 class="font-weight-bolder slider-heading">
                  INNOVATIVE EMERGENCY RESPONSE
                </h1>
              </div>
              <div class="pt-1 text-left">
                <h4 class="font-weight-normal text-colorGreen">
                  Fast and accurate alerts in critical situations.
                </h4>
              </div>
              <div class="pt-2 d-flex justify-content-start">
                <b-button
                  variant="danger"
                  size="md"
                  class="font-weight-bolder mr-2 mb-1 mb-xs-0"
                >
                  
                  Services
                </b-button>
                <b-button
                  variant="primary"
                  size="md"
                  class="first-button text-light font-weight-bolder mr-2 mb-1 mb-xs-0"
                >
                  Contact Us
                </b-button>
              </div>
            </div>
          </div>
        </b-container>
      </b-carousel-slide>

      <b-carousel-slide>
        <template #img>
          <img src="@/assets/images/home/home4.jpg" width="100%" />
          <div class="overlay"></div>
        </template>
        <b-container class="h-100">
          <div class="d-flex align-items-center h-100 pt-4">
            <div class="d-flex flex-column animate-text">
              <div class="pt-2 text-left">
                <h1 class="font-weight-bolder slider-heading">
                  INNOVATIVE EMERGENCY RESPONSE
                </h1>
              </div>
              <div class="pt-1 text-left">
                <h4 class="font-weight-normal text-colorGreen">
                  Fast and accurate alerts in critical situations.
                </h4>
              </div>
              <div class="pt-2 d-flex justify-content-start">
                <b-button
                  variant="danger"
                  size="md"
                  class="font-weight-bolder mr-2 mb-1 mb-xs-0"
                >
                  
                  Services
                </b-button>
                <b-button
                  variant="primary"
                  size="md"
                  class="first-button text-light font-weight-bolder mr-2 mb-1 mb-xs-0"
                >
                  Contact Us
                </b-button>
              </div>
            </div>
          </div>
        </b-container>
      </b-carousel-slide>

      <b-carousel-slide>
        <template #img>
          <img src="@/assets/images/home/home3.jpg" width="100%" />
          <div class="overlay"></div>
        </template>
        <b-container class="h-100">
          <div class="d-flex align-items-center h-100 pt-4">
            <div class="d-flex flex-column animate-text">
              <div class="pt-2 text-left">
                <h1 class="font-weight-bolder slider-heading">
                  INNOVATIVE EMERGENCY RESPONSE
                </h1>
              </div>
              <div class="pt-1 text-left">
                <h4 class="font-weight-normal text-colorGreen">
                  Fast and accurate alerts in critical situations.
                </h4>
              </div>
              <div class="pt-2 d-flex justify-content-start">
                <b-button
                  variant="danger"
                  size="md"
                  class="font-weight-bolder mr-2 mb-1 mb-xs-0"
                >
                  
                  Services
                </b-button>
                <b-button
                  variant="primary"
                  size="md"
                  class="first-button text-light font-weight-bolder mr-2 mb-1 mb-xs-0"
                >
                  Contact Us
                </b-button>
              </div>
            </div>
          </div>
        </b-container>
      </b-carousel-slide>
    </b-carousel>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.my-carousel {
  position: sticky;
  top: 0%;
}

.slider-heading {
  font-size: 3rem;
  color: white;
  text-shadow: 2px 2px 5px rgba(0, 0, 0, 0.7);
  line-height: 1.2;
}

.text-colorGreen {
  color: #ffffff;
}

/* Keyframe animation for fade-in effect */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.animate-text {
  animation: fadeIn 1.5s ease-in-out;
}

.my-bg {
  background-size: cover;
  background-repeat: no-repeat;
  background-blend-mode: multiply;
  height: 100%;
  width: 100%;
  transition: all 0.4s ease-in-out;
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5); /* 50% opacity */
  z-index: 1;
}
</style>
